import React from 'react';
import { useSettings, resolveAsset } from '../lib/settings';

// Sizes: 'sm' (32), 'md' (36), 'lg' (40)
const SIZES = {
  sm: { box: 'w-8 h-8', text: 'text-base' },
  md: { box: 'w-9 h-9', text: 'text-lg' },
  lg: { box: 'w-10 h-10', text: 'text-xl' },
  xl: { box: 'w-12 h-12', text: 'text-2xl' },
};

export default function BrandLogo({ size = 'md', showWordmark = true, wordmarkClass = 'text-xl', variant = 'light' }) {
  const { settings } = useSettings();
  const s = SIZES[size] || SIZES.md;
  const brandName = settings.brandName || 'Skillbridge.guru';
  const logoUrl = resolveAsset(settings.logoUrl);
  const primaryColor = variant === 'dark' ? 'text-white' : 'text-[#2b2b2b]';

  return (
    <>
      {logoUrl ? (
        <img src={logoUrl} alt={brandName} className={`${s.box} object-contain rounded-xl bg-white shadow-lg`} />
      ) : (
        <div className={`${s.box} rounded-xl bg-gradient-to-br from-[#6b47dc] via-[#a855f7] to-[#ff5722] grid place-items-center text-white font-extrabold shadow-lg ${s.text}`}>
          {(brandName[0] || 't').toUpperCase()}
        </div>
      )}
      {showWordmark && (
        <div className={`font-extrabold ${wordmarkClass} tracking-tight`}>
          <span className={primaryColor}>{brandName}</span>
        </div>
      )}
    </>
  );
}
